import React from "react";
import PageHeader from "../../components/PageHeader";
import NewsViewComponent from "../../components/News/NewsView";

class NewsView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="News Detail"
                            Breadcrumb={[
                                { name: "News", navigate: "/news" },
                                { name: "News Detail", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <NewsViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsView;
